<template>
  <div class="image">
    <img :src="`${$store.state.ASSET_URL}${image}`" alt="" />
  </div>
  <div class="info">
    <h2>
      <span>{{ title }}</span> <img src="@/assets/icons/arrow.svg" alt="" class="arrow" />
    </h2>
    <div class="cta">
      <img
        v-if="icon !== ''"
        :src="`${$store.state.ASSET_URL}${icon}`"
        alt=""
      />
      <div>
      <p class='disclaimer' v-if="hasDisclaimer && !isNaN(parseInt(starting))">*</p>
      <p v-if="isNaN(parseInt(starting))" class='small'>
        {{ starting }}
      </p>
      <p v-else>
        Starting at <span>${{ starting }}</span
        ><br />{{ per }}
      </p>
    </div>
    </div>
    <transition
      mode="out-in"
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <p class="description" v-show="active">{{ description }}</p>
    </transition>
  </div>
</template>
<script setup>
const props = defineProps({
  active: Boolean,
  hasDisclaimer:Boolean,
  title: String,
  starting: String,
  per: String,
  description: String,
  image: String,
  icon: {
    type: String,
    default: "",
  },
});
function beforeEnter(el) {
  el.style.height = 0;
}
function enter(el) {
  el.style.height = el.scrollHeight + "px";
}
function afterEnter(el) {
  //el.style.height = "auto";
}

function beforeLeave(el) {
  el.style.height = el.scrollHeight + "px";
}
function leave(el) {
  el.style.height = "0px";
}
</script>
<style lang="scss" scoped>
.disclaimer {
  padding:0 3px;
  vertical-align: top;
  position: relative;
  top:1px;
}
.cta {
  font-family: "United Sans Cd Bd";
  font-weight: bold;
  font-size: 1.785em;
  line-height: 1;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #54585a;
  margin-bottom: 8px;
  margin-top: 12px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  p {
    display: inline-block;
    span {
      color: #0076b6;
    }
  }
}
h2 {
  font-size: 2.25rem;
  font-size: 2rem;
  span {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    vertical-align: middle;
    line-height: 1;
    text-transform: uppercase;
    color: #54585a;
    text-shadow: 0px 3px 0px rgba(0, 0, 0, 0.15);
    display: inline-block;
    color: #0076b6;
    font-size: 1em;
  }
  img {
    margin-left: 12px;
    width: 7px;
    vertical-align: middle;
  }
}
.image {
  pointer-events: none;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  width: 100%;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.5s;
  }
}
.info {
  text-align: left;
  padding: 40px 60px;
  //padding-right: 15px;
  position: relative;
  &:before {
    content: "";
    background-image: url("~@/assets/images/grunge.png");
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.1;
    pointer-events: none;
  }
}
.description {
  font-family: "PF DinDisplay Pro";
  font-weight: 500;
  transform-origin: bottom left;
  transition: opacity 0.5s, height 0.5s;
  opacity: 0;
  transform: scale(0) translateY(50px);
  display: block !important;
  font-size: 1rem;
  line-height: 1;
  color: #54585a;
  text-transform: none;
  height: 0;
  overflow: hidden;
}
.small {
  font-size:1.5rem;
}
.arrow {
  display: inline-block;
}
</style>